import { loadMatomo, pushEvent } from './matomo';
import { IAnalyticsRepository, IAnalyticsParams } from './interfaces';

interface IProperties {
    userId: string;
    previousPath: string;
    experiments: Record<string, string>;
}

export default class AnalyticsRepository implements IAnalyticsRepository {
    private properties: IProperties = {
        userId: null,
        previousPath: null,
        experiments: {},
    };

    private trackUserId = (): void => {
        if (this.properties.userId) {
            pushEvent(['setUserId', this.properties.userId]);
        }
    };

    private trackPageView = (): void => {
        pushEvent(['enableHeartBeatTimer']);
        pushEvent(['setReferrerUrl', document.referrer]);
        this.trackUserId();
        pushEvent(['trackPageView']);
    };

    public getExperiments = (): Record<string, string> => this.properties.experiments;

    public getExperiment = (experiment: string): string => this.getExperiments()[experiment];

    public init = async (params: IAnalyticsParams): Promise<void> => {
        try {
            const experiments = await loadMatomo();

            if (params.userId && params.partnerCode) {
                this.properties.userId = `${params.partnerCode}_${params.userId}`;
            }

            this.properties.experiments = experiments;
            this.properties.previousPath = params.path.replace(/^\//, '');

            this.trackPageView();

            pushEvent(['enableLinkTracking']);

            pushEvent(['setCookieSameSite', 'None']);
        } catch {}
    };

    public trackLocationChange = (pathName: string): void => {
        if (typeof window === 'undefined') {
            return;
        }

        const basePath = `${window.location.origin}/`;
        const currentPath = pathName.replace(/^\//, '');

        if (currentPath === this.properties.previousPath) {
            return;
        }

        if (this.properties.previousPath) {
            pushEvent(['setReferrerUrl', `${basePath}${this.properties.previousPath}`]);
        }
        pushEvent(['setCustomUrl', `${basePath}${currentPath}`]);
        pushEvent(['trackPageView']);

        this.properties.previousPath = currentPath;
    };

    // eslint-disable-next-line class-methods-use-this
    public trackStandings = (place: string) => {
        pushEvent(['trackEvent', 'standings', place]);
    };

    // eslint-disable-next-line class-methods-use-this
    public trackBoTabSelection = (tabName: string) => {
        pushEvent(['trackEvent', 'bo_tab_selection', tabName]);
    };

    // eslint-disable-next-line class-methods-use-this
    public trackSound = (status: string) => {
        pushEvent(['trackEvent', 'sound', status]);
    };

    // eslint-disable-next-line class-methods-use-this
    public trackOpenHTP = () => {
        pushEvent(['trackEvent', 'open_htp']);
    };

    // eslint-disable-next-line class-methods-use-this
    public trackMultiPlaceBet = (page: string) => {
        pushEvent(['trackEvent', 'multi_place_bet', page]);
    };

    // eslint-disable-next-line class-methods-use-this
    public trackAmountButton = () => {
        pushEvent(['trackEvent', 'amount_button']);
    };

    // eslint-disable-next-line class-methods-use-this
    public trackPlaceBet = (uuid: string) => {
        pushEvent(['trackEvent', 'place_bet', uuid]);
    };
}
